var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3337 25.3333V29.3333H2.66699V25.3333C2.66699 24.6 3.26699 24 4.00033 24H28.0003C28.7337 24 29.3337 24.6 29.3337 25.3333Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33366 14.667H6.66699V24.0003H9.33366V14.667Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 14.667H12V24.0003H14.6667V14.667Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 14.667H17.333V24.0003H19.9997V14.667Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3337 14.667H22.667V24.0003H25.3337V14.667Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6663 30.333H1.33301C0.786341 30.333 0.333008 29.8797 0.333008 29.333C0.333008 28.7863 0.786341 28.333 1.33301 28.333H30.6663C31.213 28.333 31.6663 28.7863 31.6663 29.333C31.6663 29.8797 31.213 30.333 30.6663 30.333Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4937 7.66711L16.4937 2.86711C16.227 2.76044 15.7737 2.76044 15.507 2.86711L3.50699 7.66711C3.04033 7.85378 2.66699 8.40044 2.66699 8.90711V13.3338C2.66699 14.0671 3.26699 14.6671 4.00033 14.6671H28.0003C28.7337 14.6671 29.3337 14.0671 29.3337 13.3338V8.90711C29.3337 8.40044 28.9603 7.85378 28.4937 7.66711ZM16.0003 11.3338C14.8937 11.3338 14.0003 10.4404 14.0003 9.33378C14.0003 8.22711 14.8937 7.33378 16.0003 7.33378C17.107 7.33378 18.0003 8.22711 18.0003 9.33378C18.0003 10.4404 17.107 11.3338 16.0003 11.3338Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.4113f8e8bb7f0a9133d69338f8f0c2fe.svg";
export { ForwardRef as ReactComponent };